import type { FaireProductEntity } from "../../entity_types/product";

export const p_4g6xzctgfi: FaireProductEntity = {
  token: "p_4g6xzctgfi",
  type: "product",
  name: "Dog Days Notepad",
  brandToken: "b_de884c62",
  brandName: "E. Frances Paper",
  imageUrl:
    "https://cdn.faire.com/fastly/840d0f8038e316ee16cf3f9bf193cf2c23d99130a7f8f6721f0e73480a470539.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/3bf3ed914a64ca5687dbf74a46693c59836a08559c51b25af6de51c93988a5a7.png",
    "https://cdn.faire.com/fastly/c3c2a65781d912ce2817ea1ce89c6f44d4b8b48398e6b293f554c46e36333ad5.png",
    "https://cdn.faire.com/fastly/08fc1d62962290996502ff5609da234cb23c7a4344cbf5676b6ce87d705f8115.png",
    "https://cdn.faire.com/fastly/6c8c4b72fa7bba3d997b411b3c0a4d9061213b0e3c2a3cb8979c8e2829036f1f.png",
  ],
  priceDollars: 9,
  description:
    "Who doesn't love a fresh, crisp and clean new notepad?! It's such a hopeful item. Just think of all you will go through together! \n\nAt E. Frances, we want each page to bring joy to your list-making, doodling and note-taking.",
  tags: [],
  msrpDollars: 18,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-06-21T23:36:02.924Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
